<template>
    <div class="headingbasicdetailsrules">
        <p class="notification">Specify what constitutes a policy violation. Use the toggles on the right to turn on the rules you want to use. For configurable rules, set the values you want to use.</p>

        <h1>All Trips</h1>
        <Alltrips @allTrips="getRules" :value="getValue('allTrips')"/><hr />
        
        <h1>Air Rules</h1>
        <DomesticAirFareCap @domesticAirfareCap="getRules" :value="getValue('domesticAirfareCap')"/><hr />
        <InternationalAirFareCap @internationalAirfareCap="getRules"  :value="getValue('internationalAirfareCap')"/><hr />
        <ClassOfService @flightClassOfService="getRules"  :value="getValue('flightClassOfService')"/><hr />
        <PurchaseAirlines @hideInstantPurchase="getRules" :value="getValue('hideInstantPurchase')" /><hr />
        <AirlineVendor @airPreferredVendor="getRules" :value="getValue('airPreferredVendor')" /><hr />

        <h1>Car Rules</h1> 
        <CarVendor @carPreferredVendor="getRules"  :value="getValue('carPreferredVendor')" /><hr />
        <CarSize @carSizeGreaterThan="getRules" :value="getValue('carSizeGreaterThan')" /><hr />
        <CarAverageDailyCost @carDailyCost="getRules" :value="getValue('carDailyCost')" /><hr />

        <h1>Hotel Rules</h1> 
        <HotelVendor @hotelPreferredVendor="getRules" :value="getValue('hotelPreferredVendor')" /><hr />
        <!-- <HotelAverageDailyCost @hotelDailyCost="getRules" /><hr /> -->
        <HotelDailyCostExceptionCities  @hotelDailyCostWithExceptions="getRules" :value="getValue('hotelDailyCostWithExceptions')" />
    </div>
</template>
<script>
import Alltrips from './Rules/Alltrips.vue'
import ClassOfService from './Rules/ClassOfService.vue';
import CarSize from './Rules/CarSize.vue';
import DomesticAirFareCap from './Rules/DomesticAirFareCap.vue';
import InternationalAirFareCap from './Rules/InternationalAirFareCap.vue';
import PurchaseAirlines from './Rules/PurchaseAirlines.vue';
import AirlineVendor from './Rules/AirlineVendor.vue';
import CarVendor from './Rules/CarVendor.vue';
import HotelVendor from './Rules/HotelVendor.vue';
// import HotelAverageDailyCost from './Rules/HotelAverageDailyCost.vue';
import CarAverageDailyCost from './Rules/CarAverageDailyCost.vue';
import HotelDailyCostExceptionCities from './Rules/HotelDailyCostExceptionCities.vue';
export default {
    name : "Rules",
    props: {
    travelPolicy: {
      type: [Object],
    },
  },

    components :{
        ClassOfService,CarSize,DomesticAirFareCap,InternationalAirFareCap,PurchaseAirlines,AirlineVendor,CarVendor,HotelVendor,
        // HotelAverageDailyCost,
        CarAverageDailyCost,Alltrips,HotelDailyCostExceptionCities
    },
    data(){
        return{
           obj:{
            rules :[]
           }
        }
    },
    methods : {
        updateRules(val){
            let index = this.obj.rules.findIndex((f => f.name === val.name));
            if(index == -1) {
                this.obj.rules.push(val)
            } else {
                this.obj.rules[index] = val;
            }
        },
        getValue(name){
            
            if(this.obj){
                return this.obj.rules.find((f => f.name == name));

            }
            else return null;
            
            
        },
        getRules(val) {
           
            this.updateRules(val);
            this.$emit('rules',this.obj);
        }
    },
    mounted(){
        this.$emit('rules',this.obj);

    },
    watch: {
    
    travelPolicy: {
      handler(newVal, prevVal) {

        if(newVal.basicPolicyJson){
            var jsonData=JSON.parse(newVal.basicPolicyJson);

            this.obj.rules=jsonData.rules;
            this.$emit('rules',this.obj);

        }

     
      },
      deep: true,
    }
      
}
}
</script>

